module.exports = __webpack_public_path__ + "static/media/roadmap-mobile.e54d751b.svg";